module.exports = __webpack_public_path__ + "static/img/nogoods.44c6922.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nogoods.png
// module id = edJB
// module chunks = 1